import { subscriptionsApi } from 'api'
import { ProcessingKey } from 'constants/rootConstants'
import { useZustandGlobalLocalStore } from 'zustandGlobalLocalStore'
import { useZustandStore } from 'zustandGlobalStore'
import { fetchGeoData } from './fetchGeoData'

export const createCohortLead = async (): Promise<void> => {
  useZustandStore.getState().startProcessing(ProcessingKey.CREATE_COHORT_LEAD)

  const initialCohort = useZustandStore.getState().initialCohort
  const leadId = useZustandStore.getState().lead?.id || ''

  const geoDataResponse = await fetchGeoData()

  const response = await subscriptionsApi.createCohortLead({
    cohort: initialCohort,
    geo: {
      city: geoDataResponse?.city || '',
      country: geoDataResponse?.country || '',
      region: geoDataResponse?.region || null,
      postalCode: geoDataResponse?.postalCode || null,
      ip: geoDataResponse?.ip || null,
      timezone: geoDataResponse?.timezone || null,
    },
    leadId,
  })

  if (response && response.data) {
    const lead = response.data
    useZustandStore.setState({ lead })
    useZustandGlobalLocalStore.setState((state) => ({
      previousLeadId: state.previousLeadId || lead.id,
    }))
  }

  useZustandStore.getState().stopProcessing(ProcessingKey.CREATE_COHORT_LEAD)
}
